import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';

import { ContentPageCardDataLayerContainer } from
  '../../containers/ContentPageCardDataLayerContainer/ContentPageCardDataLayerContainer';
import { navigationHooks } from '../../hooks/navigationHooks/navigationHooks';
import { ContentPageCardPresentational } from '../ContentPageCard/ContentPageCard';
import { Link, LinkIconPosition, LinkIntent, LinkType } from '../Link/Link';
import { Typography } from '../Typography/Typography';
import styles from './ContentPagesSection.module.css';

export type ContentPageItem = ContentPageCardPresentational & {
  id?: string;
};

export type Props = {
  isAllBlogHidden?: boolean;
  isBodyADate?: boolean;
  items: ContentPageItem[];
  title?: JSX.Element;
};

const messages = defineMessages({
  showMore: {
    id: 'src.components.ContentPagesSection.showMore',
    defaultMessage: 'See all blogs',
  },
});

export const ContentPagesSection = React.memo((props: Props) => {
  const {
    items,
    title,
    isBodyADate,
    isAllBlogHidden,
  } = props;

  const blogRedirect = navigationHooks.useBlogRedirect();

  return items.length ? (
    <div className={styles.contentPagesSection}>
      <div className={styles.contentPagesSectionInner}>
        {title}

        <div className={styles.items}>
          {items.map((item, key) => (
            <ContentPageCardDataLayerContainer
              key={item.id || `article-card-${key}`}
              id={item.id}
              position={key}
              isBodyADate={isBodyADate}
              body={item.body}
              title={item.title}
              image={item.image}
              link={item.link}
            />
          ))}
        </div>
        {!isAllBlogHidden
          && <Link
            type={LinkType.Href}
            intent={LinkIntent.primary}
            to={blogRedirect}
            iconPosition={LinkIconPosition.Right}
          >
            <Typography className={styles.showMore} variant='bodySubText2'>
              <FormattedMessage {...messages.showMore} />
            </Typography>
          </Link>
        }

      </div>
    </div>
  ) : null;
});

ContentPagesSection.displayName = 'ContentPagesSection';
